import { render } from "./ContactView.vue?vue&type=template&id=d9a088ee&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=d9a088ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9a088ee"]])

export default __exports__